import { render, staticRenderFns } from "./CustomerComplaint.vue?vue&type=template&id=097886d3"
import script from "./CustomerComplaint.vue?vue&type=script&lang=js"
export * from "./CustomerComplaint.vue?vue&type=script&lang=js"
import style0 from "./CustomerComplaint.vue?vue&type=style&index=0&id=097886d3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports